module.exports = __webpack_public_path__ + "static/media/icon-event__revolucion-rusa-hover.0b374908.svg";